import React from "react";
import { Box, Flex } from "rebass";

import { H1, PrimaryButton, Text, GradientCard } from "components";

export const Hero = (props) => {
  if (props.primary) {
    return (
      <Box bg="white">
        <Box
          w="100%"
          mx="auto"
          pt={[137, 80]}
          pb={[4, 5, 6]}
          px={[4, 5, 6, 8]}
          style={{ maxWidth: "90em" }}
        >
          <Flex
            is="section"
            flexDirection={["column", null, "row"]}
            align="center"
            mt={[5, 6]}
            mb={[5, 6]}
          >
            <Box
              position="relative"
              style={{ zIndex: 1 }}
              w={[1, null, 1 / 2]}
              mb={[5, null, 0]}
              mr={[0, null, 4]}
              pr={[0, null, 4]}
            >
              {props.primary.title && props.primary.title[0] && (
                <H1
                  children={props.primary.title[0].text}
                  mb={5}
                  mr={[0, null, -10]}
                  fontSize={[6, 7]}
                />
              )}
              {props.primary.subtitle && props.primary.subtitle[0] && (
                <Text
                  children={props.primary.subtitle[0].text}
                  fontSize={[2, 3]}
                  mb={48}
                />
              )}
              {props.primary.button_label && props.primary.button_link && (
                <PrimaryButton
                  children={props.primary.button_label}
                  is="a"
                  href={props.primary.button_link}
                />
              )}
            </Box>
            <Box w={[1, null, 1 / 2]} position="relative" style={{ zIndex: 0 }}>
              <GradientCard
                image={props.primary.image ? props.primary.image.half.url : ""}
              >
                <Box pb="100%" />
              </GradientCard>
            </Box>
          </Flex>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/slices/Hero/Hero.js